var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWithLayout',[_c('h2',{staticClass:"screen_out"},[_vm._v("Blog")]),_c('SectionNotice',{attrs:{"isActive":_vm.sectionsTop.notice.show,"viewModel":_vm.viewModel}}),_c('SectionPost',{attrs:{"isActive":_vm.sectionsTop.post.show,"viewModel":_vm.viewModel}}),_c('SectionLetter',{attrs:{"isActive":_vm.sectionsTop.letter.show}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }